<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.33325 1.2832L6.04992 5.99987L1.33325 10.7165" stroke="currentColor" stroke-width="1.66667" stroke-miterlimit="10" stroke-linecap="square"/>
</svg>
